/**
 * Sales > Summary (default sub-route).
 *
 * Tabs-updates: redesigned from the daily queue into a summary dashboard
 * (leads, lead actions, opportunities, opportunity actions, tasks). The
 * daily queue still lives on the Home view.
 */

import { createFileRoute } from '@tanstack/react-router';

import { SummaryDashboard } from '@/components/sales/SummaryDashboard';

export const Route = createFileRoute('/sales/')({
  component: () => <SummaryDashboard />,
});
